export function getPage(path) {
  return fetch(`${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_page?slug=${path}`, {
    method: 'GET'
  })
    .then((res) => {
      if(!res.ok) {
        throw Error('Response error');
      }
      return res.json();
    })
    .then((data) => data);
}
